import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export const equipmentTypes = [
    { name: 'Dator', id: 0 },
    { name: 'Läsplatta', id: 1 },
    { name: 'Mobiltelefon', id: 2 },
    { name: 'Nycklar', id: 3 },
    { name: 'SIM-Kort', id: 4 },
    { name: 'Övrigt', id: 5 },
    { name: 'Tillbehör', id: 6 }
];

export class Equipment extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            if (this.EquipmentType != null) {
                this.EquipmentType = equipmentTypes[this.EquipmentType];
                if (this.EquipmentType == null)
                    throw "Invalid equipment type";
            }

            this.LoanDate = utility.parseDate(this.LoanDate);
            this.ExpireDate = utility.parseDate(this.ExpireDate);
            this.ReturnDate = utility.parseDate(this.ReturnDate);
        }
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Organization = ctx.getOrganization(this.OrganizationId);
        this.Person = ctx.getPerson(this.PersonId);
    }

    toJSON() {
        var ret = super.toJSON();
        if (ret.EquipmentType != null) {
            ret.EquipmentType = ret.EquipmentType.id;
        }
        ret.OrganizationId = BaseObject.withRelated(ret, "Organization");
        ret.PersonId = BaseObject.withRelated(ret, "Person");
        return ret;
    }
}
